import Image from "next/image";
import React from "react";

import feedbackForm from "assets/teams/template-form.png";
import brandAssets from "assets/teams/template-brand-assets.png";
import employeeIndex from "assets/teams/template-employee-index.png";
import ArrowRight from "assets/iconsv2/arrow-right-16.svg";

import teamsStyles from "../../styles/teams.module.css";

import styles from "./TeamsExtensionsTemplate.module.css";

const TeamsExtensionsTemplate: React.FC = () => {
  return (
    <>
      <div className={teamsStyles.titleSubtitle}>
        <span className={styles.comingSoon}>Coming Soon</span>
        <h2>Easily customizable extension templates</h2>

        <p>
          Quickly set up your first Private Extension and speed up common workflows that best suit your team&rsquo;s
          needs.
        </p>
      </div>

      <div className={styles.templates}>
        <div>
          <div className={styles.imgContainer}>
            <div>
              <Image alt="Power up your team" src={feedbackForm} width={380} height={160} layout="fixed" />
            </div>
          </div>
          <strong>Feedback form</strong>
          <p>Let your team share actionable feedback about features in development, to speed up shipping.</p>
        </div>
        <div>
          <div className={styles.imgContainer}>
            <div>
              <Image alt="Power up your team" src={brandAssets} width={380} height={160} layout="fixed" />
            </div>
          </div>
          <strong>Design system color picker</strong>
          <p>
            Make your design system available to everybody in your company with quick access to colors, icons, and more.
          </p>
        </div>
        <div>
          <div className={styles.imgContainer}>
            <div>
              <Image alt="Power up your team" src={employeeIndex} width={380} height={160} layout="fixed" />
            </div>
          </div>
          <strong>Employee index</strong>
          <p>
            Build an index to search and get to know your teammates better. And make it easy for new joiners to discover
            your organization.
          </p>
        </div>
      </div>

      <div className={styles.linkContainer}>
        <a href="mailto:hello+team-templates@raycast.com" className={styles.mailtoLink}>
          Tell us what you&rsquo;re looking for{" "}
          <i>
            <ArrowRight className="icon" />
          </i>
        </a>
      </div>
    </>
  );
};

export default TeamsExtensionsTemplate;
